import { render, staticRenderFns } from "./ConfigAlertDatadog.vue?vue&type=template&id=f5f16092&scoped=true"
import script from "./ConfigAlertDatadog.vue?vue&type=script&lang=js"
export * from "./ConfigAlertDatadog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f16092",
  null
  
)

export default component.exports